import React from "react";
import Chart from "react-apexcharts/dist/react-apexcharts.esm.js";

const colors = [
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7300",
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
];

// Configuration for different endpoint display settings
const ENDPOINT_CONFIGS = {
  preventiveMaintenanceDashboardGraphRoute: {
    xAxisType: "category",
    categories: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    maxCategories: 12,
  },
  default: {
    xAxisType: "numeric",
    categories: null,
    maxCategories: 31,
  },
};

const MultiLineGraph = ({ data, target }) => {
  // Get configuration based on endpoint
  const config = ENDPOINT_CONFIGS[data.endpoint] || ENDPOINT_CONFIGS.default;

  // Process categories based on configuration
  let categories;
  if (config.categories) {
    // Use predefined categories (like month names)
    categories = config.categories.slice(0, data.graphData[0].slice(2).length);
  } else {
    // Use numeric categories (days)
    categories = data.graphData[0].slice(2).map((_, index) => index + 1);
  }

  const series = data.graphData.map((seriesData, index) => ({
    name: seriesData[1],
    data: seriesData.slice(2),
    color: colors[index % colors.length],
  }));

  const options = {
    chart: {
      type: "line",
      height: 200,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: colors,
    },
    markers: {
      size: 4,
      colors: colors,
      strokeColors: "#fff",
      strokeWidth: 1,
      hover: {
        size: 6,
      },
    },
    xaxis: {
      categories: categories,
      type: config.xAxisType,
      ...(config.xAxisType === "numeric" && {
        min: 1,
        max: config.maxCategories,
      }),
      labels: {
        style: {
          colors: "rgba(0,0,0,0.5)",
        },
        ...(config.xAxisType === "numeric" && {
          formatter: function (val) {
            return Math.floor(val);
          },
        }),
      },
      axisBorder: {
        color: "rgba(0,0,0,0.1)",
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "rgba(0,0,0,0.5)",
        },
      },
    },
    grid: {
      borderColor: "rgba(0,0,0,0.1)",
      strokeDashArray: 3,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    tooltip: {
      shared: true,
      intersect: false,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const categoryLabel = config.categories
          ? config.categories[dataPointIndex]
          : `Day ${dataPointIndex + 1}`;

        let tooltipContent = `<div style="padding: 8px; background: rgba(255, 255, 255, 0.9); border: 1px solid #ccc; border-radius: 4px;">`;
        tooltipContent += `<div style="font-size: 11px; margin-bottom: 4px;">${categoryLabel}</div>`;

        series.forEach((seriesData, index) => {
          const seriesName = w.globals.seriesNames[index];
          const value = seriesData[dataPointIndex];
          const color = colors[index % colors.length];
          tooltipContent += `<div style="font-size: 12px; color: ${color}; font-weight: bold;">${seriesName}: ${value.toFixed(
            2
          )}</div>`;
        });

        tooltipContent += `</div>`;
        return tooltipContent;
      },
    },
    annotations: {
      yaxis: [
        {
          y: target,
          borderColor: "rgba(255,165,0,1)",
          strokeDashArray: 5,
          borderWidth: 2,
          label: {
            text: `Target: ${target}`,
            style: {
              color: "#fff",
              background: "rgba(255,165,0,1)",
            },
          },
        },
      ],
    },
    colors: colors,
    fill: {
      type: "solid",
      opacity: 1,
    },
  };

  return (
    <div style={{ width: "100%", height: "200px" }}>
      <Chart options={options} series={series} type="line" height="100%" />
    </div>
  );
};

export default MultiLineGraph;
